var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40065 15.1667H4.60065C1.99398 15.1667 0.833984 14.0067 0.833984 11.4V8.60004C0.833984 5.99337 1.99398 4.83337 4.60065 4.83337H7.40065C10.0073 4.83337 11.1673 5.99337 11.1673 8.60004V11.4C11.1673 14.0067 10.0073 15.1667 7.40065 15.1667ZM4.60065 5.83337C2.53398 5.83337 1.83398 6.53337 1.83398 8.60004V11.4C1.83398 13.4667 2.53398 14.1667 4.60065 14.1667H7.40065C9.46732 14.1667 10.1673 13.4667 10.1673 11.4V8.60004C10.1673 6.53337 9.46732 5.83337 7.40065 5.83337H4.60065Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4007 11.1667H10.6673C10.394 11.1667 10.1673 10.94 10.1673 10.6667V8.60004C10.1673 6.53337 9.46732 5.83337 7.40065 5.83337H5.33398C5.06065 5.83337 4.83398 5.60671 4.83398 5.33337V4.60004C4.83398 1.99337 5.99398 0.833374 8.60065 0.833374H11.4007C14.0073 0.833374 15.1673 1.99337 15.1673 4.60004V7.40004C15.1673 10.0067 14.0073 11.1667 11.4007 11.1667ZM11.1673 10.1667H11.4007C13.4673 10.1667 14.1673 9.46671 14.1673 7.40004V4.60004C14.1673 2.53337 13.4673 1.83337 11.4007 1.83337H8.60065C6.53398 1.83337 5.83398 2.53337 5.83398 4.60004V4.83337H7.40065C10.0073 4.83337 11.1673 5.99337 11.1673 8.60004V10.1667Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.0737637bede76bd76c0e56e550222e85.svg";
export { ForwardRef as ReactComponent };